import styled from 'styled-components';
import { rem } from '../../utils/functions.js';
import { DROPDOWN_VARIANT, LISTBOX_MAX_HEIGHT } from './constants.js';
import { typography } from '../../typography/typography.js';

var Root = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__Root",
  componentId: "sc-1d3l53r-0"
})(["width:240px;box-sizing:border-box;display:inline-block;vertical-align:middle;", ""], function (_ref) {
  var rootStyle = _ref.rootStyle;
  return rootStyle;
});
process.env.NODE_ENV !== "production" ? Root.displayName = 'Root' : void 0;
var StyledDropdown = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__StyledDropdown",
  componentId: "sc-1d3l53r-1"
})(["position:relative;"]);
process.env.NODE_ENV !== "production" ? StyledDropdown.displayName = 'StyledDropdown' : void 0; // Styled components for DropdownInput

var getBorderColor = function getBorderColor(_ref2) {
  var outline = _ref2.outline,
      theme = _ref2.theme;
  return outline ? theme.colorPalette.utilityColors.error : theme.colorPalette.neutralColors.light.shade_dark_3;
};

var getBackgroundColor = function getBackgroundColor(_ref3) {
  var variant = _ref3.variant,
      disabled = _ref3.disabled,
      theme = _ref3.theme;

  if (variant === DROPDOWN_VARIANT.BASIC_LINE_DASHED) {
    return 'transparent';
  }

  if (disabled) {
    return theme.colorPalette.neutralColors.light.shade_light_2;
  }

  return theme.colorPalette.neutralColors.light.shade_white;
};

var getBorderWidth = function getBorderWidth(_ref4) {
  var variant = _ref4.variant,
      outline = _ref4.outline;

  if (outline) {
    if (variant !== DROPDOWN_VARIANT.BASIC) {
      return '0px 0px 2px 0px';
    }

    return '2px';
  }

  if (variant === DROPDOWN_VARIANT.BASIC) {
    return '1px';
  }

  return '0px 0px 1px 0px';
};

var DropdownInputWrapper = /*#__PURE__*/styled.button.withConfig({
  displayName: "styledComponents__DropdownInputWrapper",
  componentId: "sc-1d3l53r-2"
})(["padding:0;margin:0;position:relative;display:inline-block;width:100%;background-color:", ";border-color:", ";border-style:", ";border-width:", ";border-bottom-style:", ";&:after{left:0;right:0;bottom:0;content:'';position:absolute;height:2px;z-index:2;transform:", ";transition:transform 200ms cubic-bezier(0,0,0.2,1) 0ms;border-bottom:1px solid ", ";pointer-events:none;}&:hover{border-color:", ";& > button{text-decoration:none;color:", ";cursor:default;}}", ""], getBackgroundColor, getBorderColor, function (_ref5) {
  var disabled = _ref5.disabled;
  return disabled ? 'none' : 'solid';
}, getBorderWidth, function (_ref6) {
  var variant = _ref6.variant;
  return variant === DROPDOWN_VARIANT.BASIC_LINE_DASHED ? 'dashed' : 'solid';
}, function (_ref7) {
  var expanded = _ref7.expanded;
  return expanded ? 'scaleX(1)' : 'scaleX(0)';
}, getBorderColor, function (_ref8) {
  var outline = _ref8.outline,
      disabled = _ref8.disabled,
      theme = _ref8.theme;

  if (disabled) {
    return 'none';
  }

  if (outline) {
    return theme.colorPalette.utilityColors.error;
  }

  return theme.colorPalette.neutralColors.light.shade_dark_3;
}, function (_ref9) {
  var disabled = _ref9.disabled,
      theme = _ref9.theme;
  return disabled ? theme.colorPalette.neutralColors.dark.shade_light_1 : theme.colorPalette.primaryColors.main.shade_default;
}, function (_ref10) {
  var dropdownInputStyle = _ref10.dropdownInputStyle;
  return dropdownInputStyle;
});
process.env.NODE_ENV !== "production" ? DropdownInputWrapper.displayName = 'DropdownInputWrapper' : void 0;
var DropdownSelectWrapper = /*#__PURE__*/styled.select.withConfig({
  displayName: "styledComponents__DropdownSelectWrapper",
  componentId: "sc-1d3l53r-3"
})(["appearance:none;border-radius:0;width:100%;height:", ";font-family:", ";font-size:", ";color:", ";padding:0 30px 0 12px;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;background-color:", ";border-color:", ";border-width:", ";border-style:solid;border-bottom-style:", ";&::-ms-expand{display:none;}", ""], rem(48), typography.fontFamily, typography.fontSize, function (_ref11) {
  var theme = _ref11.theme,
      disabled = _ref11.disabled;
  return disabled ? theme.colorPalette.neutralColors.dark.shade_light_4 : theme.colorPalette.neutralColors.dark.shade_light_1;
}, getBackgroundColor, getBorderColor, getBorderWidth, function (_ref12) {
  var variant = _ref12.variant;
  return variant === DROPDOWN_VARIANT.BASIC_LINE_DASHED ? 'dashed' : 'solid';
}, function (_ref13) {
  var dropdownInputStyle = _ref13.dropdownInputStyle;
  return dropdownInputStyle;
});
process.env.NODE_ENV !== "production" ? DropdownSelectWrapper.displayName = 'DropdownSelectWrapper' : void 0;
var ToggleIconWrapper = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__ToggleIconWrapper",
  componentId: "sc-1d3l53r-4"
})(["position:absolute;right:16px;top:", ";transform:", ";pointer-events:none;"], rem(12), function (_ref14) {
  var expanded = _ref14.expanded;
  return expanded ? 'rotate(180deg)' : '';
});
process.env.NODE_ENV !== "production" ? ToggleIconWrapper.displayName = 'ToggleIconWrapper' : void 0;
var Placeholder = /*#__PURE__*/styled.div.withConfig({
  displayName: "styledComponents__Placeholder",
  componentId: "sc-1d3l53r-5"
})(["width:100%;height:calc(", " - 2px);color:", ";text-decoration:none;font-family:", ";font-size:", ";font-weight:500;text-align:left;outline-style:none;border:none;padding:0 30px 0 12px;box-sizing:border-box;cursor:default;white-space:nowrap;text-overflow:ellipsis;overflow:hidden;display:flex;align-items:center;&.disabled{color:", ";pointer-events:none;}"], rem(48), function (_ref15) {
  var theme = _ref15.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_1;
}, typography.fontFamily, typography.fontSize, function (_ref16) {
  var theme = _ref16.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_4;
});
process.env.NODE_ENV !== "production" ? Placeholder.displayName = 'Placeholder' : void 0; // Styled components for DropdownMenu

var DropdownMenuWrapper = /*#__PURE__*/styled.ul.withConfig({
  displayName: "styledComponents__DropdownMenuWrapper",
  componentId: "sc-1d3l53r-6"
})(["text-align:left;box-shadow:0 1px 5px 0 rgba(0,0,0,0.15);min-width:100%;max-height:", "px;padding-left:0px;margin-top:0px;overflow-y:auto;overflow-wrap:break-word;transition:max-height 0.2s;position:absolute;z-index:9;&::before{left:5px;top:-5px;content:'';position:absolute;width:10px;height:10px;background-color:", ";transform:rotate(45deg);}", ""], LISTBOX_MAX_HEIGHT, function (_ref17) {
  var theme = _ref17.theme;
  return theme.colorPalette.neutralColors.light.shade_white;
}, function (_ref18) {
  var dropdownMenuStyle = _ref18.dropdownMenuStyle;
  return dropdownMenuStyle;
});
process.env.NODE_ENV !== "production" ? DropdownMenuWrapper.displayName = 'DropdownMenuWrapper' : void 0;
var DropdownItem = /*#__PURE__*/styled.li.withConfig({
  displayName: "styledComponents__DropdownItem",
  componentId: "sc-1d3l53r-7"
})(["position:relative;display:block;font-family:", ";font-size:", ";line-height:", ";text-align:left;border:1px solid transparent;border-width:", ";border-color:", ";font-weight:", ";color:", ";padding-left:20px;padding-top:10px;padding-bottom:10px;white-space:normal;background:", ";&:hover:not(.disabled){font-weight:600;text-decoration:none;background:", ";}&.disabled{color:", ";background-color:", ";border:1px solid transparent;border-color:", ";}"], typography.fontFamily, typography.fontSize, typography.lineHeight, function (_ref19) {
  var isSelected = _ref19.isSelected;
  return isSelected ? '1px 1px 1px 4px' : '1px';
}, function (_ref20) {
  var isSelected = _ref20.isSelected,
      theme = _ref20.theme;
  return isSelected ? "transparent ".concat(theme.colorPalette.neutralColors.light.shade_dark_3, "\n    ").concat(theme.colorPalette.neutralColors.light.shade_default, " ").concat(theme.colorPalette.primaryColors.main.shade_default) : "transparent ".concat(theme.colorPalette.neutralColors.light.shade_dark_3, "\n    ").concat(theme.colorPalette.neutralColors.light.shade_default, " ").concat(theme.colorPalette.neutralColors.light.shade_dark_3);
}, function (_ref21) {
  var isSelected = _ref21.isSelected;
  return isSelected ? 600 : 300;
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_1;
}, function (_ref23) {
  var theme = _ref23.theme;
  return theme.colorPalette.neutralColors.light.shade_white;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.colorPalette.neutralColors.light.shade_light_1;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.colorPalette.neutralColors.dark.shade_light_4;
}, function (_ref26) {
  var theme = _ref26.theme;
  return theme.colorPalette.neutralColors.light.shade_white;
}, function (_ref27) {
  var theme = _ref27.theme;
  return "transparent ".concat(theme.colorPalette.neutralColors.light.shade_dark_3, "\n      ").concat(theme.colorPalette.neutralColors.light.shade_default, " ").concat(theme.colorPalette.neutralColors.light.shade_dark_3);
});
process.env.NODE_ENV !== "production" ? DropdownItem.displayName = 'DropdownItem' : void 0;

export { DropdownInputWrapper, DropdownItem, DropdownMenuWrapper, DropdownSelectWrapper, Placeholder, Root, StyledDropdown, ToggleIconWrapper };
